import React from 'react';
//import logo from './logo.svg';
//import './App.css';
import './App.scss';

import $ from 'jquery';
declare global {
    interface Window {
        jQuery: typeof $;
        $: typeof $;
    }
}
window.jQuery = window.$ = $;


export enum UIPanelEnum {
    Unused,

    ShowSearchContacts,
    ContactSearchResults,
    ShowContact,
    EditContact,
};


type AppProps = any;

export default class App extends React.Component<AppProps, any> {
    private matchMediaSmall:  MediaQueryList | undefined;
    private matchMediaMedium: MediaQueryList | undefined;
    private matchMediaLarge:  MediaQueryList | undefined;

    private AppHeader:    JSX.Element;
    private HeaderNavLeft: JSX.Element;
    private HeaderNavRight: JSX.Element;
    private StatusBar:     JSX.Element | null;

    constructor(props: AppProps) {
        super(props);
        this.AppHeader = <span>Client List</span>;
        this.HeaderNavLeft = <li><button type="button">navigation 1</button></li>;
        this.HeaderNavRight = <li><button type="button">navigation R1</button></li>;
        this.StatusBar = <div>Status Bar</div>
        //this.StatusBar = <StatusBar />;
    }


    componentDidMount() {
        const self = this;
        //console.log('App.js - componentDidMount');

        self.matchMediaSmall  = self.getMatchMediaSmall();
        self.matchMediaMedium = self.getMatchMediaMedium();
        self.matchMediaLarge  = self.getMatchMediaLarge();

        self.matchMediaSmall.addListener(self.matchMediaSmallListener);
        self.matchMediaMedium.addListener(self.matchMediaMediumListener);
        self.matchMediaLarge.addListener(self.matchMediaLargeListener);

        self.matchMediaSmallListener(self.matchMediaSmall);
        self.matchMediaMediumListener(self.matchMediaMedium);
        self.matchMediaLargeListener(self.matchMediaLarge);

        $(".sidebar-left.empty").click(function() {
            //console.log("sidebar-left.empty click() -> %s", this.className);
            $(".not-empty").trigger("hideSideBar", ["sidebar-left not-empty"]);
            $(".sidebar-left.not-empty").show(250, function() {
                // Animation complete.
                $(this).css("display", "flex");
            });
        });

        $(".sidebar-right.empty").click(function() {
            //console.log("sidebar-right.empty click() -> %s", this.className);
            $(".not-empty").trigger("hideSideBar", ["sidebar-right not-empty", "xxx"]);
            $(".sidebar-right.not-empty").show(250, function() {
                // Animation complete.
                $(this).css("display", "flex");
            });
        });

        // Hide the not-empty sidebar when it is clicked.
        $(".not-empty").click(function() {
            if (self.matchMediaSmall && self.matchMediaSmall.matches) {
                // Only hide when screen is in small width.
                $(this).hide(200);
            }
        });

        // However, do NOT hide the not-empty sidebar if a search-input is clicked.
        $(".search-input input").click(function() {
            // Do nothing here.
            //console.log("input ignore click()");
            return false;
        });

        $(".not-empty").on("hideSideBar", function(event, ignoreClassName1, param2) {
            //console.log("this.className=%s, ignoreClassName1=%s, param2=%s", this.className, ignoreClassName1, param2);
            if (this.className !== ignoreClassName1) {
                // Do not animate here. It causes a "flash".
                $(this).hide();
            }
        });
    }


    componentWillUnmount() {
        console.log('App.js - componentWillUnmount');

        //TODO: undo stuff from componentDidMount()
    }


    //------------------------------------------------------------------------------
    // Small Listener
    //TODO: fix :any
    matchMediaSmallListener(match: any) {
        //const self = this;
        if (match.matches) {
            //TODO: only call the following when [display!='none']
            $(".not-empty").trigger("hideSideBar");
            //$(".sidebar-left.not-empty").hide();
            //$(".sidebar-right.not-empty").hide();
        } else {
            //
        }
    }

    // Medium Listener
    //TODO: fix :any
    matchMediaMediumListener(match: any) {
        //const self = this;
        if (match.matches) {
            //a[href="https://example.com"]
            //$(".sidebar-left.not-empty[display='none']").css("display", "initial");
            //$(".sidebar-right.not-empty[display='none']").css("display", "initial");
            //TODO: only call the following when [display='none']
            $(".sidebar-left.not-empty").show();
            $(".sidebar-right.not-empty").show();
        } else {
            //
        }
    }

    // Large Listener
    //TODO: fix :any
    matchMediaLargeListener(match: any) {
        //const self = this;
        //TODO: matchMediaLargeListener(match)
        //return self.matchMediaMediumListener(match);
    }


    //TODO: the following values MUST be set at compile time and shared with SASS!!!

    //------------------------------------------------------------------------------
    // Small Screen
    // @media screen and (max-width: 767.98px)
    getMatchMediaSmall() {
        return window.matchMedia("(max-width: 767.98px)");
    }

    // Medium Screen
    // @media screen and (min-width: 768px) /**and (max-width: 991.98px)**/
    getMatchMediaMedium() {
        return window.matchMedia("(min-width: 768px)");
    }

    // Large Screen
    // @media screen and (min-width: 992px)
    getMatchMediaLarge() {
        return window.matchMedia("(min-width: 992px)");
    }


    //------------------------------------------------------------------------------
    render() {
        // Remember - this function must be pure!
        return (
          <div className="grid-container">
            {/*}
            <header>
                <h1 className="app-header">
                    {this.AppHeader}
                </h1>
            </header>

            <nav className="header-nav left-right-nav">
                <ul className="left-side-nav">
                    {this.HeaderNavLeft}
                </ul>
                <ul className="right-side-nav">
                    {this.HeaderNavRight}
                </ul>
            </nav>

            <aside className="sidebar-left not-empty">
                {this.appLeftPanel(this.props.leftPanel)}
            </aside>

            <aside className="sidebar-right not-empty">
                <div className="sidebar-right-header">
                    {this.appRightHeaderPanel(UIPanelEnum.Unused)}
                </div>
                <div className="sidebar-right-body">
                    {this.appRightPanel(UIPanelEnum.Unused)}
                </div>
                <div className="sidebar-right-footer">
                    {this.appRightFooterPanel(UIPanelEnum.Unused)}
                </div>
            </aside>

            <aside className="sidebar-left empty">&#x276F;</aside>
            <aside className="sidebar-right empty">&#x276E;</aside>
            {*/}

            <article>
                {this.appMainPanel(this.props.mainPanel)}
            </article>

            {/*}
            <footer className="statusbar">
                {this.StatusBar}
            </footer>
          {*/}

          </div>
        );
    }

    private appLeftPanel(panelEnum: any) {
        return null;
        //return <span>Left sidebar panel</span>;
    };


    private appMainPanel(panelEnum: any) {
        return (
            <table>
                <tbody>
                    <tr>
                      <td></td> <td></td> <td className="ca"></td> <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td className="taylor">taylor</td>
                        <td className="ca" rowSpan={2}><div>.ca</div></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td></td>
                        <td className="software">software</td>
                        <td></td>
                    </tr>
                    <tr>
                      <td></td> <td></td> <td className="ca"></td> <td></td>
                    </tr>
                </tbody>
            </table>
        );
        /**
        return (
            <React.Fragment>
                <div className="taylor">taylor</div>
                <div className="software">software</div>
                <div className="ca">ca</div>
            </React.Fragment>
        );
        **/
    };


    private appRightPanel(panelEnum: any) {
        return null;
        //return <span>Right sidebar panel</span>;
    };


    private appRightHeaderPanel(panelEnum: any) {
        return null;
    };


    private appRightFooterPanel(panelEnum: any) {
        return null;
    };

}